import { useQuery } from '@tanstack/react-query';
import { api } from '../api';

export interface TrendData {
  month: string;
  totalAmount: number;
  claimCount?: number;
}

export interface SystemStats {
  pendingClaimsCount: number;
  pendingFinanceRM: number;
  totalUsers: number;
  trendData: TrendData[];
}

export interface PersonalStats {
  myDraftsCount: number;
  myPendingCount: number;
  ytdApprovedRM: number;
  trendData: TrendData[];
}

export const statsKeys = {
  all: ['stats'] as const,
  system: () => [...statsKeys.all, 'system'] as const,
  personal: () => [...statsKeys.all, 'personal'] as const,
};

export function useSystemStats() {
  return useQuery({
    queryKey: statsKeys.system(),
    queryFn: () => api.get<SystemStats>('/stats/system'),
  });
}

export function usePersonalStats() {
  return useQuery({
    queryKey: statsKeys.personal(),
    queryFn: () => api.get<PersonalStats>('/stats/personal'),
  });
}
